"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useragent_1 = require("./useragent");
exports.UserAgentInfo = useragent_1.UserAgentInfo;
exports.USERAGENT_DIRECTIVE = [useragent_1.UserAgentInfo];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2032928750/src/~/ng2-responsive/useragent/index.js
// module id = fQpS
// module chunks = 6